module.exports = __webpack_public_path__ + "static/web-trafik-5b58be13277722bc3d6f4fe0cd36cfbc.png";